import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin, setToken, apiErr } from "@/lib/adminApi";
import { Lock, Loader2, Zap } from "lucide-react";

export const AdminLogin = () => {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await adminLogin(email.trim(), password);
      setToken(res.data.token);
      nav("/admin");
    } catch (err) {
      setError(apiErr(err));
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="relative z-[2] min-h-screen grid place-items-center px-6">
      <form onSubmit={submit} className="w-full max-w-sm border border-white/10 bg-[#0f0f11] p-8 rounded-2xl">
        <div className="flex items-center gap-2 mb-8">
          <span className="grid place-items-center w-8 h-8 bg-[#e2ff00] text-black rounded-sm"><Zap size={18} strokeWidth={2.5} /></span>
          <span className="font-display font-extrabold tracking-tight text-lg">OG VAULT · Admin</span>
        </div>
        <label className="block font-mono text-[11px] uppercase tracking-[0.2em] text-[#8b8b93] mb-2">E-Mail</label>
        <input
          data-testid="admin-email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full bg-black/40 border border-white/10 focus:border-[#e2ff00] rounded-md px-4 py-3 mb-4 outline-none"
          placeholder="admin@ogvault.de"
        />
        <label className="block font-mono text-[11px] uppercase tracking-[0.2em] text-[#8b8b93] mb-2">Passwort</label>
        <input
          data-testid="admin-password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full bg-black/40 border border-white/10 focus:border-[#e2ff00] rounded-md px-4 py-3 mb-5 outline-none"
          placeholder="••••••••"
        />
        {error && <div data-testid="admin-login-error" className="text-sm text-[#ff0055] font-mono mb-4">{error}</div>}
        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={loading}
          className="w-full flex items-center justify-center gap-2 bg-[#e2ff00] text-black font-mono text-sm uppercase tracking-[0.2em] py-3.5 rounded-full hover:bg-white transition-colors disabled:opacity-60"
        >
          {loading ? <Loader2 size={16} className="animate-spin" /> : <Lock size={16} />} Anmelden
        </button>
      </form>
    </div>
  );
};
